import React, { Component } from "react";
import classnames from "classnames";

import * as styles from "./FilterToggle.scss";
import { HeaderButton } from "./HeaderButton";

export interface IFilterToggleProps {
    onClicked: () => void;
    active?: boolean;
    className?: string;
}

export class FilterToggle extends Component<IFilterToggleProps> {
    public render() {
        const { active, className, onClicked } = this.props;

        return (
            <HeaderButton
                icon="filter"
                onClicked={onClicked}
                className={classnames(
                    styles["filter-toggle"],
                    active && styles.active,
                    className,
                )}
                data-tooltip="Toggle filters"
                data-testid="toggle-filter"
            />
        );
    }
}
